import { createContext, useCallback, useContext, useState } from "react";
import IT from "@/i18n/it";

let current = localStorage.getItem("hs_lang") || ((navigator.language || "").toLowerCase().startsWith("it") ? "it" : "en");
document.documentElement.lang = current;
export const getLang = () => current;

const Ctx = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setL] = useState(current);
  const setLang = (l) => {
    current = l;
    localStorage.setItem("hs_lang", l);
    document.documentElement.lang = l;
    setL(l);
  };
  const t = useCallback((s, vars) => {
    let out = lang === "it" ? (IT[s] ?? s) : s;
    if (vars) Object.entries(vars).forEach(([k, v]) => { out = out.replaceAll(`{${k}}`, v); });
    return out;
  }, [lang]);
  return <Ctx.Provider value={{ lang, setLang, t }}>{children}</Ctx.Provider>;
};

export const useT = () => useContext(Ctx);

export const LangSwitch = ({ testid = "lang-switch" }) => {
  const { lang, setLang } = useT();
  return (
    <div className="inline-flex self-start md:self-auto w-fit rounded-full border border-[#0F4C5C]/30 p-0.5 text-xs font-semibold" data-testid={testid}>
      {["en", "it"].map((l) => (
        <button key={l} onClick={() => setLang(l)} data-testid={`${testid}-${l}`}
          className={`px-2.5 py-1 rounded-full uppercase transition-colors ${lang === l ? "bg-[#0F4C5C] text-[#F4E9D8]" : "text-[#0F4C5C] hover:text-[#E36414]"}`}>
          {l}
        </button>
      ))}
    </div>
  );
};
